import { render, staticRenderFns } from "./VerkaFooter.vue?vue&type=template&id=4e7a8a60&scoped=true&"
import script from "./VerkaFooter.vue?vue&type=script&lang=ts&"
export * from "./VerkaFooter.vue?vue&type=script&lang=ts&"
import style0 from "./VerkaFooter.vue?vue&type=style&index=0&id=4e7a8a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7a8a60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFooter,VRow})
